module.exports = __webpack_public_path__ + "img/edit_task.33023be1.svg";